import { render, staticRenderFns } from "./RelatorioAulasPorAluno.vue?vue&type=template&id=6449371d"
import script from "./RelatorioAulasPorAluno.vue?vue&type=script&lang=js"
export * from "./RelatorioAulasPorAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports